import { v4 as uuid } from "uuid";
import { OrderRepositoryImpl } from "../../../domain/orderRepositoryImpl/OrderRepositoryImpl";

const orderRepo = OrderRepositoryImpl.getInstance();

const placeNewOrder = (auth: string, apiUrl: () => string): Promise<void> => {
  try {
    const newOrderId = uuid();

    return orderRepo.placeOrder(newOrderId, auth, apiUrl);
  } catch (error) {
    console.log(error);

    return Promise.reject(error);
  }
};

export { placeNewOrder };
